<template>
  <div v-if="player.has_web_login" class="player-reset-password-wrap" @click.stop>
    <a-popconfirm
      title="Выдать новый пароль? Старый перестанет работать."
      ok-text="Выдать"
      cancel-text="Отмена"
      @confirm="$emit('reset', player)"
    >
      <a-button type="link" size="small" class="reset-web-password-btn" :loading="loading">
        Выдать новый пароль
      </a-button>
    </a-popconfirm>
  </div>
</template>

<script>
export default {
  name: 'TeamPlayerResetPasswordButton',
  props: {
    player: { type: Object, required: true },
    loading: { type: Boolean, default: false }
  },
  emits: ['reset']
};
</script>

<style scoped>
.player-reset-password-wrap {
  margin-top: 4px;
}

.reset-web-password-btn {
  padding: 0;
  height: auto;
  font-size: 12px;
}
</style>
